import styled from 'styled-components'

export const Container = styled.section`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 100px 32px 194px;
  width: 100%;

  @media (max-width: 950px) {
    padding: 19px 32px 62px;
  }
`

export const Content = styled.div`
  align-items: center;
  display: flex;
  gap: 32px;
  justify-content: space-between;
  max-width: 1032px;
  width: 100%;

  @media (max-width: 950px) {
    max-width: 613px;
  }
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 408px;
  width: 100%;

  h1 {
    font-size: 32px;
    line-height: 40px;
  }

  p {
    font-size: 24px;
    line-height: 32px;
  }

  span {
    font-size: 16px;
    line-height: 24px;
  }

  @media (max-width: 950px) {
    max-width: initial;
  }

  @media (max-width: 764px) {
    h1 {
      font-size: 24px;
      line-height: 32px;
    }

    p {
      font-size: 16px;
      line-height: 24px;
    }
  }
`

export const ImageContainer = styled.figure`
  aspect-ratio: 1;
  border-radius: 20px;
  max-width: 508px;
  height: 100%;
  max-height: 508px;
  width: 100%;

  @media (max-width: 950px) {
    &.desktop {
      display: none;
    }
  }

  @media (min-width: 951px) {
    &.mobile {
      display: none;
    }
  }
`

export const TeamCard = styled.div`
  align-items: center;
  border: 1px solid #E0E0E0;
  border-radius: 10px;
  display: flex;
  gap: 8px;
  padding: 6px 16px;
  width: fit-content;

  span {
    line-height: 24px;
    white-space: nowrap;
  }
`
